import { getIsBitSet, ListViewBitFlagsMasks } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';

export default function isSenderImageEnabled() {
    return !getIsBitSet(ListViewBitFlagsMasks.HideSenderImage);
}
